import React from "react";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { AgingReportDto } from "../../../../interfaces/agingReport/agingReport";
import { badgeBaseClass, EmptyStateWidget } from "../utils/HomeTabUtils";

interface HomeAgingTabProps {
  reports: AgingReportDto[];
  loading: boolean;
  onSelectReport: (item: AgingReportDto) => void;
  limit?: number;
}

const HomeAgingTab: React.FC<HomeAgingTabProps> = ({ 
  reports, 
  loading, 
  onSelectReport, 
  limit = 4 
}) => {
  if (reports.length === 0) {
    return (
      <div className="text-center">
        <div>{loading ? <span><Spinner size="sm" /> Loading...</span> : <EmptyStateWidget />}</div>
      </div>
    );
  }

  return (
    <div className="common_content_inner mby_t_24">
      <div className="task-list-container">
        {[...reports]
          .sort((a, b) => (b.agingDays || 0) - (a.agingDays || 0))
          .slice(0, limit)
          .map((item) => (
            <div
              key={item.agingId || item.participantId}
              className="task-card cursor-pointer"
              onClick={() => onSelectReport(item)}
            >
              <div className="task-card-content">
                <div className="task-info-left">
                  <span className="top-header">{item.waiver}</span>
                  <span className="aging-participant-name">
                    {" "}
                    {item.firstName} {item.lastName}
                  </span>
                </div>
                <div className="task-info-right">
                  <span className="top-header mr-[0.8rem]">
                    {moment.utc(item.linkageDate).local().format("MM/DD/YYYY")}
                  </span>
                  <span className={`${badgeBaseClass} bg-[#EA9CEB] !important ps-task-frequency-new badge-text-due px-[0.4rem]`}>
                    Aging - {Math.round(item.agingDays)}
                  </span>
                  <span className={`${badgeBaseClass} bg-[#FF9E9E] !important ps-task-frequency-new badge-text-due px-[0.4rem]`}>
                    {item.currentStatus ?? "--"}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default HomeAgingTab;